import { render, staticRenderFns } from "./ShareUsers.vue?vue&type=template&id=dcbaaf0c"
import script from "./ShareUsers.vue?vue&type=script&lang=ts"
export * from "./ShareUsers.vue?vue&type=script&lang=ts"
import style0 from "./ShareUsers.vue?vue&type=style&index=0&id=dcbaaf0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports